import "./UploadArea.css"
import imgIcon from "../../assets/img.png"
import { useSelector, useDispatch } from "react-redux"
import { setFile } from "../../actions"

const UploadArea = () => {

    const file = useSelector(state => state.file)
    const dispatch = useDispatch()

    const onFileChange  = (e) => {
        dispatch(setFile(e.target.files[0]))
    }

    const fileToImage = (file) => {
        return file.currentFile ? URL.createObjectURL(file.currentFile) :  URL.createObjectURL(file.prevFile)
    }

    return(
        <div className="UploadArea">
            <label htmlFor="imgUpload" id="uploadBtn"> 
                {
                    file ? 
                        <>
                            <img id="demoImg" src={fileToImage(file)} alt="" />
                        </>
                        :
                        <>
                            <img src={imgIcon} alt="" />
                            <span>Upload an Image</span>
                        </>
                }
            </label>
            <input onChange={onFileChange} type="file" maxLength={1} accept="image/*"  style={{ display: 'none' }} id="imgUpload"/>
        </div>
        
    )
}

export default UploadArea